import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatDate } from "@/lib/utils-app";
import { logError } from "@/lib/logger";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/audit-logs");
        setLogs(data);
      } catch (err) {
        if (err?.response?.status !== 401) logError("[audit] load:", err);
      }
    })();
  }, []);
  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-7xl">
      <div className="text-xs uppercase tracking-[0.25em] font-bold text-neutral-500 mb-3">Rastreabilidade</div>
      <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Audit Logs</h1>
      <div className="mt-8 bg-white border border-neutral-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 border-b border-neutral-200 text-neutral-500 text-xs uppercase tracking-wider">
            <tr>
              <th className="px-4 py-3 text-left font-semibold">Quando</th>
              <th className="px-4 py-3 text-left font-semibold">Usuário</th>
              <th className="px-4 py-3 text-left font-semibold">Ação</th>
              <th className="px-4 py-3 text-left font-semibold">Alvo</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-neutral-100">
            {logs.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-neutral-500">Sem eventos.</td></tr>}
            {logs.map((l) => (
              <tr key={l.log_id} className="hover:bg-neutral-50">
                <td className="px-4 py-3 text-neutral-600 text-xs">{formatDate(l.created_at)}</td>
                <td className="px-4 py-3">{l.actor_email}</td>
                <td className="px-4 py-3 font-mono text-xs bg-neutral-50 inline-block rounded px-2 py-0.5 mt-2">{l.action}</td>
                <td className="px-4 py-3 font-mono">{l.target}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
